import { 
  db,
  Timestamp,
  collection,
  limit,
  orderBy,
  where,
  query,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
} from "../../firebase";
import { PositionType } from "../entities/position";
import PositionRepository from "../usecases/ports/positionRepository";
import { data as constants } from "../../constants";

export default class PositionFirebaseImpl implements PositionRepository {
  fetchPositions = async (
    limitQuery?: number,
    whereQuery?: [
      string,
      "<" | "<=" | "==" | ">=" | ">",
      string | number | boolean
    ][]
  ): Promise<PositionType[]> => {
    try {
      const queryConstraints: any[] = [orderBy("createdAt", "desc")];
      const positionRef =  collection(db, "position");

      const dataArray: any[] = [];

      if (limitQuery) {
        queryConstraints.push(limit(limitQuery));
      }

      if (whereQuery && whereQuery.length > 0) {
        whereQuery.forEach((element) => {
          queryConstraints.push(where(element[0], element[1], element[2]));
        });
      }

      const q = query(positionRef, ...queryConstraints);

      const positionDocData = await getDocs(q);

      if (positionDocData.empty && positionDocData.metadata.fromCache) {
        throw new Error(constants.commonNetworkError);
      }

      positionDocData.docs.forEach((doc) => {
        const data = doc.data();

        dataArray.push({
          ...data,
          key: doc.id,
        });
      });

      return dataArray;
    } catch (error) {
      throw error;
    }
  };

  addPosition = async (position: PositionType) => {
    try {
      const positionRef =  collection(db, "position");
      const timestamp = Timestamp.now();
      const positionData = {
        ...position,
        createdAt: timestamp,
        updatedAt: timestamp,
      };
      if (!navigator.onLine) {
        throw new Error(constants.commonNetworkError);
      }
      await addDoc(positionRef, positionData);
    } catch (error) {
      throw error;
    }
  };

  fetchPosition = async (id: string): Promise<Partial<PositionType>> => {
    try {
      const positionDocRef = doc(db, "position", id);
      const positionDocData = await getDoc(positionDocRef);
      if (positionDocData.metadata.fromCache) {
        throw new Error(constants.commonNetworkError);
      }

      const position = positionDocData.data();
      return position as Partial<PositionType>;
    } catch (error) {
      throw error;
    }
  };

  updatePosition = async (
    id: string,
    data: Partial<PositionType>
  ): Promise<Partial<PositionType>> => {
    try {
      if (!navigator.onLine) {
        throw new Error(constants.commonNetworkError);
      }
      const positionRef =  doc(db, "position", id);
      await updateDoc(positionRef, data);
      return data;
    } catch (error) {
      throw error;
    }
  };
}
